
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Da gehen die Meinungen auseinander. Die Schweizerische Kopfwehgesellschaft rät: Medikamente wenn möglich vermeiden. Die deutsche Leitlinie dagegen nennt als Behandlung Paracetamol Acetylsalicylsäure (bekannt zum Beispiel als ASS oder Aspirin), Naproxen, Metamizol (jeweils 500 bis 1000 mg) oder Ibuprofen (200 bis 400 mg). Zehnprozentiges Pfefferminzöl, auf die schmerzhaften Stellen des Kopfes aufgetragen, wirkt ähnlich gut wie Schmerzmittel. `}</p>
    <p>{`Hier finden Sie einen Überblick über die wichtigsten Wirkstoffe und ihre Eigenschaften:`}</p>
    <div className='ui stackable centered grid'>
  <div className='five wide column'>
    <div className='mediTable'>
      <b>Paracetamol</b><br /><br />
      <span className='label'>Medikamente</span>
     Dafalgan, Panadol, Ben-u-ron, Acetalgin
      <span className='label'>Eigenschaften</span>
      schmerzlindernd, fiebersenkend, nicht entzündungshemmend
      <span className='label'>Wichtigste Nebenwirkungen</span>
      Leberschädigung bei geringer Überdosierung
      <span className='label'>Maximal-Dosis Erwachsene</span>
      4000 mg/Tag, nicht länger als eine Woche
      <span className='label'>Dauer bis Wirkung</span>
      ca. 30 Minuten, wirkt 4 bis 6 Stunden
    </div>
  </div>
      <div className='five wide column'>
  <div className='mediTable'>
    <b>NSAR</b>
    <br />
    nichtsteroidale Antirheumatika
    <span className='label'>Medikamente</span>
    Ibuprofen (Irfen, Algifor, Dolo-Spedifen, Dismenol, Saridon), Diclofenac
    (Voltaren, Tonopan, Naproxen (Aleve)
    <span className='label'>Eigenschaften</span>
    Schmerzlindernd, entzündungshemmend, leicht fiebersenkend
    <span className='label'>Wichtigste Nebenwirkungen</span>
    Magenschleimhaut-Entzündungen, Magengeschwüre, Magen-Darm-Blutungen,
    Nierenschädigung bei Überdosierung
    <span className='label'>Maximal-Dosis Erwachsene</span>
    Ibuprofen: 1200 mg/Tag
    <br />
    Diclofenac: 75mg/Tag
    <br />
    Naproxen: 660mg/Tag
    <br />
    Nicht länger als 3 Tage
    <span className='label'>Dauer bis Wirkung</span>
    ca. 15 min, wirkt 4 bis 6 Stunden
  </div>
      </div>
      <div className='five wide column'>
  <div className='mediTable'>
    <b>ASS</b>
    <br />
    Acetylsalicylsäure
    <span className='label'>Medikamente</span>
    Aspirin, Alka Seltzer, Aspegic, Alcacyl
    <span className='label'>Eigenschaften</span>
    Schmerzlindernd, blutverdünnend, leicht entzündungshemmend, leicht
    fiebersenkend
    <span className='label'>Wichtigste Nebenwirkungen</span>
    Magenschleimhaut-Entzündungen, Magengeschwüre, Magen-Darm-Blutungen,
    Nierenschädigung bei Überdosierung, zusätzlich weitere Blutungen aufgrund
    der Blutverdünnung
    <span className='label'>Maximal-Dosis Erwachsene</span>
    3000 mg/Tag, nicht länger als 3 Tage
    <span className='label'>Dauer bis Wirkung</span>
    ca. 15 min, wirkt 4 bis 6 Stunden
  </div>
      </div>
    </div>
    <span style={{
      fontSize: '.7em'
    }}>Quelle: <Link href='https://www.srf.ch/news/panorama/risiko-schmerztablette-umstritten-aber-ungebrochen-beliebt' mdxType="Link">SRF</Link></span>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;